export default __webpack_public_path__ + "static/media/lion_opt.e661a8f3.gif";